// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c8f64d57","404":"2e6a20a7","778":"862fbc05"}[chunkId] + ".chunk.js";
};